const TPC_URL = "https://preview.insightwin.com/backend/tpc";

export default TPC_URL;
